import React from 'react';
import '../styles/components/HeroSection.css';

const HeroSection = ({ heroTitle, heroSubtitle, onExploreClick, onGetQuoteClick }) => {
  return (
    <section className="flex-hero">
      <div className="hero-content">
        <h1 className="hero-title">{heroTitle}</h1>
        <p className="hero-subtitle">{heroSubtitle}</p>
        <div className="hero-buttons">
          <button 
            className="explore-service-button"
            onClick={onExploreClick}
          >
            Explore service
          </button>
          <button 
            className="get-quote-hero-button"
            onClick={onGetQuoteClick}
          >
            Get Quote
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
